import { cn } from '@library/component-utils/cn';

export function DrawerContent({
  className = '',
  children,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      {...props}
      className={cn(
        'text-soClean-100 flex flex-grow flex-col gap-6 p-4',
        className
      )}
    >
      {children}
    </div>
  );
}
